import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import storage from '@/utlis/storage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/rexinfang/logindex.vue'),
    meta: { requireAuth: false } // 标记这个页面不需要认证
  },
  {
    path: '/logindex',
    name: 'logindex',
    component: () => import('@/rexinfang/logindex.vue'),
    meta: { requireAuth: false } // 标记这个页面不需要认证
  },
  {
    path: '/advise',
    name: 'advise',
    component: () => import('@/rexinfang/advise.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/log',
    name: 'log',
    component: () => import('@/rexinfang/log.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/logdetail',
    name: 'logdetail',
    component: () => import('@/rexinfang/logdetail.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/rexinfang/news.vue'),
    //  某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/pass',
    name: 'pass',
    component: () => import('@/rexinfang/pass.vue'),
    //  某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/rexinfang/help.vue'),
    // meta: {
    //   requireAuth: true
    // }
  },
  {
    path: '/flogin',
    name: 'flogin',
    component: () => import('@/rexinfang/flogin.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/portal',
    name: 'portal',
    component: () => import('@/rexinfang/portal.vue'),
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/portalnm',
    name: 'portalnm',
    component: () => import('@/rexinfang/portalNiMing.vue'),
    meta: {
      requireAuth: false
    }
  }

]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 设置路由守卫，在进页面之前，判断有token，才进入页面，否则返回登录页面
if (storage.get('token')) {
  store.commit('setToken', storage.get('token'))
}
router.beforeEach((to, from, next) => {
  if (to.path === '/flogin' && !to.query.redirect) {
    // 如果目标页面是登录页面，且没有 `redirect` 参数，说明是直接访问登录页面
    return next() // 跳过后续的验证逻辑
  }
  // 判断要去的路由有没有requiresAuth
  // to.matched.some(r => r.meta.requireAuth) or to.meta.requiresAuth
  // 判断要去的路由是否需要认证，`meta.requiresAuth` 来标识
  if (to.matched.some(r => r.meta.requireAuth)) {
    try {
      if (store.state.token) {
        console.log('有token的情况:', to.fullPath)
        next() //  有token,进行request请求，后台还会验证token
      } else {
        // 如果没有 token，跳转到登录页面，并携带当前页面的路径，方便登录后跳回
        console.log('没有token的情况:', to.fullPath)
        // if (to.path !== '/portal') {
        //   next({
        //     path: '/portal',
        //     // 将刚刚要去的路由path（却无权限）作为参数，方便登录成功后直接跳转到该路由，这要进一步在登陆页面判断
        //     query: { redirect: to.fullPath }
        //   })
        // } else {
          next()
        // }
      }
    } catch (error) {
      console.error('Error in router guard:', error)
    }
  } else {
    next() //  如果无需token,那么随它去吧
  }
})

export default router
